import { PackageTemplate } from '@raskrask-dk/bookingflow-state-machine'
import { IPackageCard } from '@raskrask-dk/rr-components/lib/Organisms/PackageModal/props'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { getIsMobile } from '../../../redux/reducers/appSettings'
import { setIsServicePickerOpen } from '../../../redux/reducers/calendarSettings'
import PackageModalBody from '../calendarComponents/packagemodalbody'
import { PackageCard } from '../../../types/interfaceextension'
import { PackageModal } from '@raskrask-dk/rr-components'
import { GoalBF } from '../../../models'

export const KlippekortPackageModal = ({
  goBack,
  setPackageTemplate,
  setIsModalOpen,
  setModalType,
  inspectedPackage,
  selectedGoal,
  packageBFs,
  packageBF,
}: {
  goBack: () => void
  setPackageTemplate: (template: PackageTemplate | undefined) => void
  setIsModalOpen: (value: boolean) => void
  setModalType: (value: ModalType) => void
  inspectedPackage: PackageCard
  selectedGoal: GoalBF
  packageBFs: IPackageCard[]
  packageBF: IPackageCard
}): ReactElement => {
  const { t } = useTranslation()
  const isMobile = useAppSelector((state) => getIsMobile(state))
  const dispatch = useAppDispatch()

  const onClickClose = () => {
    // go back to calendar
    goBack()
  }

  const onClickCTA = () => {
    // go to partner selection
    setPackageTemplate(inspectedPackage.template)

    setIsModalOpen(false)
    setModalType('PartnerInfo')
    dispatch(setIsServicePickerOpen(false))
  }

  return (
    <PackageModal
      type={isMobile ? 'drawer' : 'modal'}
      open
      body={PackageModalBody(t(`klippeCard_Body${selectedGoal.id}`))}
      ctaText={t('calendar.package.pickpackagecta')}
      packages={packageBFs}
      selectedPackage={packageBF}
      title={t('calendar.package.pickpackage.title')}
      onClose={onClickClose}
      onClickCTA={onClickCTA}
    />
  )
}
